class CotterEnum {
  static DefaultUSCode: string = "+1";

  // default container ID
  static DefaultContainerID: string = "cotter-form-container";

  static AssetURL = "https://js.cotter.app";
  static BackendURL = "https://www.cotter.app/api/v0";
  static JSURL = "https://js.cotter.app";
  static WorkerURL = "https://worker.cotter.app"
}

export default CotterEnum;
